module.exports = __webpack_public_path__ + "static/media/bg_trapezoid.b9ed06c3.svg";